<div class="flex items-center gap-2 rounded-xl border border-n30 bg-n10 px-3 py-2 focus-within:border-b300 transition-colors"
     [class.w-full]="isFullWidth">
  <i class="ph ph-magnifying-glass text-n400 text-base flex-shrink-0"></i>
  <form class="flex-1">
    <input
      id="searchInput"
      #searchInput
      type="search"
      (keydown.esc)="searchInput.value = ''; onSearchChange()"
      (keydown.enter)="onSearchChange()"
      [placeholder]="placeholder"
      [formControl]="searchControl"
      class="w-full bg-transparent outline-none text-sm text-n900 placeholder-n400 border-0 p-0"
    />
  </form>
</div>
